import { Text, Heading, VStack, Stack, StackProps } from '@chakra-ui/react'
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { preventOrphanWords } from '@src/lib/textUtils'
import React, { ReactElement } from 'react'

interface LPBlockProps {
  bgColor?: string
  cards: ReactElement[] // Array of React elements to be rendered
  paddingX?: number
  paddingY?: number
  subtitle?: string
  textStackProps?: StackProps
  title?: string
  titleColor?: string
}

const LPBlock: React.FC<LPBlockProps> = ({
  bgColor,
  cards,
  paddingX,
  paddingY,
  subtitle,
  textStackProps,
  title,
}) => {
  const { getBreakpointValue } = useBreakpointContext()

  return (
    <SectionWrapper bgColor={bgColor} paddingX={paddingX} paddingY={paddingY}>
      <VStack align={'center'} gap={getBreakpointValue([10, 20])} width={'full'}>
        <Stack
          align={'center'}
          borderRadius={'3xl'}
          direction={'column'}
          flexGrow={1}
          gap={getBreakpointValue([5, 10, 10])}
          width={'full'}
        >
          <VStack align={'center'} gap={5} {...textStackProps}>
            <Heading
              fontWeight={700}
              marginTop={getBreakpointValue([4, 0])}
              size={getBreakpointValue(['3xl', '4xl', '5xl'])}
              textAlign={'center'}
            >
              {title}
            </Heading>
            {subtitle && (
              <Text
                as={'span'}
                color={'fg.muted'}
                fontSize={getBreakpointValue(['xl', '3xl'])}
                fontWeight={600}
                textAlign={'center'}
                dangerouslySetInnerHTML={{
                  __html: preventOrphanWords(subtitle),
                }}
              />
            )}
          </VStack>

          {/* Render passed components */}
          <VStack width={'full'}>
            {cards.map((card, index) => (
              <VStack key={index} gap={10} width={'full'}>
                {card}
              </VStack>
            ))}
          </VStack>
        </Stack>
      </VStack>
    </SectionWrapper>
  )
}

export default LPBlock
